module.exports = __webpack_public_path__ + "static/media/caret-down-dark.9da94c9c.svg";